module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2014 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Lim, Eng-Beng, 1973-")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Brown boys and rice queens : spellbinding performance in the Asias / Eng-Beng Lim.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN 978-0-8147-6089-5 (hardback) — ISBN 978-0-8147-5940-0 (pb)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("1. Queer theory—Asia—Case studies. 2. Sex role—Asia—Case studies. 3. Asia—Race")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("relations—Case studies. 4. Orientalism—Case studies. 5. Postcolonialism—Asia—Case")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("studies. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("HQ76.3.A78L56 2013")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("305.3095—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("2013017728")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Book design by Marcelo Agudo")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Also available as an ebook.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12612b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0